<template>
  <div class="right-sidebar">
    <div v-if="ticket" class="right-sidebar-content">
      <!-- Тікет закритий section -->
      <div class="action-section">
        <div class="action-header" @click="toggleSection('closed')">
          <i
            :class="[
              'mdi',
              expandedSections.closed
                ? 'mdi-chevron-down'
                : 'mdi-chevron-right',
            ]"
          ></i>
          <span>Тікет закритий</span>
          <button class="action-menu-btn">
            <i class="mdi mdi-dots-horizontal"></i>
          </button>
        </div>
        <div v-if="expandedSections.closed" class="action-content">
          <!-- Closed ticket actions -->
        </div>
      </div>

      <!-- Тікет передзкритий section -->
      <div class="action-section">
        <div class="action-header" @click="toggleSection('preopened')">
          <i
            :class="[
              'mdi',
              expandedSections.preopened
                ? 'mdi-chevron-down'
                : 'mdi-chevron-right',
            ]"
          ></i>
          <span>Тікет перевідкритий</span>
          <button class="action-menu-btn">
            <i class="mdi mdi-dots-horizontal"></i>
          </button>
        </div>
        <div v-if="expandedSections.preopened" class="action-content">
          <!-- Preopened ticket actions -->
        </div>
      </div>

      <!-- Рішення до тікету section -->
      <SolutionSection
        :ticket="ticket"
        :expanded="expandedSections.solution"
        @toggle="(val) => updateSection('solution', val)"
        @show-details="$emit('show-solution-details')"
      />

      <!-- Причина перевідкриття section -->
      <div v-if="ticket.reopenComment" class="action-section">
        <div class="action-header" @click="toggleSection('reopen')">
          <i
            :class="[
              'mdi',
              expandedSections.reopen
                ? 'mdi-chevron-down'
                : 'mdi-chevron-right',
            ]"
          ></i>
          <span>Причина перевідкриття</span>
          <button class="action-menu-btn">
            <i class="mdi mdi-dots-horizontal"></i>
          </button>
        </div>
        <div v-if="expandedSections.reopen" class="action-content">
          <div class="reopen-info">
            <div class="reopen-text">
              {{ ticket.reopenComment }}
            </div>
            <div v-if="ticket.reopenDatetime" class="detail-row">
              <i class="mdi mdi-calendar-clock"></i>
              <div>
                <label>Дата перевідкриття</label>
                <p>{{ ticket.reopenDatetime }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionSection from "./SolutionSection.vue";

export default {
  name: "RightSidebar",
  components: {
    SolutionSection,
  },
  props: {
    ticket: {
      type: Object,
      default: null,
    },
    expandedSections: {
      type: Object,
      default: () => ({
        closed: false,
        preopened: false,
        solution: false,
        reopen: false,
      }),
    },
  },
  emits: ["update-sections", "show-solution-details"],
  methods: {
    toggleSection(section) {
      this.$emit("update-sections", {
        section,
        value: !this.expandedSections[section],
      });
    },
    updateSection(section, value) {
      this.$emit("update-sections", { section, value });
    },
  },
};
</script>

<style scoped>
.right-sidebar {
  width: 300px;
  background: white;
  border-left: 1px solid #e9ecef;
  overflow-y: auto;
  flex-shrink: 0;
}

.right-sidebar-content {
  padding: 16px;
}

.action-section {
  margin-bottom: 16px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: white;
}

.action-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  position: relative;
}

.action-header i:first-child {
  font-size: 16px;
}

.action-header span {
  flex: 1;
}

.action-menu-btn {
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;
}

.action-menu-btn:hover {
  background: #f8f9fa;
}

.action-content {
  padding: 12px;
  border-top: 1px solid #e9ecef;
}

.reopen-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.reopen-text {
  font-size: 13px;
  line-height: 1.6;
  color: #212529;
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding: 12px;
  background: #fff3cd;
  border-radius: 6px;
  border-left: 3px solid #ffc107;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 6px;
}

.detail-row i {
  font-size: 18px;
  color: #6c757d;
  flex-shrink: 0;
  margin-top: 2px;
}

.detail-row label {
  display: block;
  font-size: 11px;
  color: #6c757d;
  margin-bottom: 2px;
  font-weight: 500;
}

.detail-row p {
  margin: 0;
  font-size: 12px;
  color: #212529;
  font-weight: 500;
}

@media (max-width: 1200px) {
  .right-sidebar {
    width: 260px;
  }
}

@media (max-width: 992px) {
  .right-sidebar {
    width: 100%;
    border-left: none;
    border-top: 1px solid #e9ecef;
    max-height: 300px;
  }
}

@media (max-width: 768px) {
  .right-sidebar {
    max-height: 250px;
  }

  .right-sidebar-content {
    padding: 12px;
  }

  .action-section {
    margin-bottom: 12px;
  }

  .action-header {
    padding: 10px;
    font-size: 12px;
  }

  .action-content {
    padding: 10px;
  }

  .reopen-text {
    font-size: 12px;
    padding: 10px;
  }

  .detail-row {
    padding: 6px;
  }

  .detail-row i {
    font-size: 16px;
  }

  .detail-row label {
    font-size: 10px;
  }

  .detail-row p {
    font-size: 11px;
  }
}

@media (max-width: 576px) {
  .right-sidebar {
    width: 100%;
    max-height: none;
  }
}

@media (max-width: 768px) and (orientation: landscape) {
  .right-sidebar {
    width: 220px;
    max-height: none;
    border-left: 1px solid #e9ecef;
    border-top: none;
  }
}
</style>
